const encodeLiveChatCTAV2Data = data => window.btoa(unescape(encodeURIComponent(JSON.stringify(data))));

const decodeBase64Json = encoded => {
  if (!encoded) return {};
  try {
    return JSON.parse(decodeURIComponent(escape(window.atob(encoded)))) || {};
  } catch {
    return {};
  }
};

const readLegacyLiveChatCTAV2FromNode = node => {
  const textSpans = [...node.querySelectorAll(".button--livechat-cta-v2__text > span")];
  const icon = node.querySelector(".button--livechat-cta-v2__icon");

  return {
    twoLine: node.classList.contains("button--livechat-cta-v2--two-line") || textSpans.length > 1,
    line1: textSpans[0]?.textContent ?? "",
    line2: textSpans[1]?.textContent ?? "",
    bgColor: node.getAttribute("data-bg-color") ?? "",
    textColor: node.getAttribute("data-text-color") ?? "",
    iconSrc: icon?.getAttribute("src") ?? "",
    url: node.getAttribute("href") ?? "",
    pulsingAnimation: node.classList.contains("animated-button"),
    spaceBellow: node.classList.contains("mb-16px"),
  };
};

const readLiveChatCTAV2FromNode = node => {
  const encoded = node.getAttribute("live-chat-cta-v2-data");

  return encoded ? decodeBase64Json(encoded) : readLegacyLiveChatCTAV2FromNode(node);
};

export { readLiveChatCTAV2FromNode, encodeLiveChatCTAV2Data };
